import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { DateTimeService } from '@shared/services/DateTimeService';
import { utcToZonedTime } from 'date-fns-tz';
import { LINKS_COLOR, TEXT_COLOR } from '../../theme';

const ChoosenSlotContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const ResetButton = styled.button`
  font-size: 12px;
  font-weight: bold;
  line-height: 1.17;
  color: ${LINKS_COLOR};
  padding: 7px;
  border: 1px solid ${LINKS_COLOR};
  border-radius: 6px;
  background: #fff;
  margin-left: 8px;
  
  &:hover {
    opacity: 0.8;
  }
  
  &:focus {
    outline: none;
    opacity: 0.8;
  }
`;

const ChosenSlotTitle = styled.div`
  font-size: 16px;
  font-weight: 800;
  line-height: 1.38;
  letter-spacing: 0.2px;
  color: ${TEXT_COLOR};
  margin: 32px 0 3px; 
`;

const ChosenSlot = ({ onClickResetSlot, slot, hasResetButton }) => (
  <div>
    <ChosenSlotTitle>Ma réservation</ChosenSlotTitle>
    <ChoosenSlotContainer>
      {DateTimeService.setDateLocale(utcToZonedTime(new Date(slot.start_date), 'Europe/Paris'), 'E d MMM yyyy HH:mm')}
      {hasResetButton && <ResetButton onClick={onClickResetSlot} type="button">Modifier</ResetButton>}
    </ChoosenSlotContainer>
  </div>
);

ChosenSlot.propTypes = {
  onClickResetSlot: PropTypes.func,
  slot: PropTypes.object.isRequired,
  hasResetButton: PropTypes.bool,
};

ChosenSlot.defaultProps = {
  onClickResetSlot: () => {},
  hasResetButton: false,
};

export { ChosenSlot };
